import type { FunctionComponent } from 'react';

type TransactionPatternsProps = {
  patterns?: Array<Record<string, unknown>>;
};

const getPatternTypeStyles = (type: string) => {
  switch (type) {
    case 'velocity':
      return 'bg-purple-100 text-purple-800';
    case 'geographic':
      return 'bg-blue-100 text-blue-800';
    case 'amount':
      return 'bg-green-100 text-green-800';
    case 'timing':
      return 'bg-orange-100 text-orange-800';
    case 'behavioral':
      return 'bg-pink-100 text-pink-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

const getRiskBadgeStyles = (riskLevel: string) => {
  switch (riskLevel) {
    case 'high':
      return 'bg-red-100 text-red-800';
    case 'medium':
      return 'bg-yellow-100 text-yellow-800';
    default:
      return 'bg-green-100 text-green-800';
  }
};

export const TransactionPatterns: FunctionComponent<TransactionPatternsProps> = ({ patterns }) => {
  if (!patterns || patterns.length === 0) {
    return null;
  }

  return (
    <div className="rounded-lg border bg-white p-6 shadow-sm">
      <h2 className="text-xl font-semibold" style={{ color: '#14203D' }}>
        Detected Patterns
      </h2>

      <div className="mt-4 space-y-3">
        {patterns.map((pattern, index) => (
          <div key={index} className="rounded-lg border p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <h3 className="font-medium text-gray-900">{pattern.name as string}</h3>
                <span
                  className={`rounded-full px-2 py-0.5 text-xs font-medium ${getPatternTypeStyles(pattern.type as string)}`}
                >
                  {pattern.type as string}
                </span>
              </div>
              <span
                className={`rounded-full px-2 py-0.5 text-xs font-medium ${getRiskBadgeStyles(pattern.riskLevel as string)}`}
              >
                {pattern.riskLevel as string} risk
              </span>
            </div>
            <p className="mt-2 text-sm text-gray-600">{pattern.description as string}</p>
            <p className="mt-1 text-xs text-gray-500">
              Affected transactions: {pattern.affectedTransactions as number}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
